var map = {
	"./apollo/a1.jpeg": 46,
	"./apollo/a2.jpeg": 2945,
	"./apollo/a3.jpeg": 1493,
	"./axtria/1.jpeg": 2995,
	"./axtria/2.jpeg": 7185,
	"./axtria/3.jpeg": 5436,
	"./axtria/4.jpeg": 6511,
	"./axtria/5.jpeg": 1519,
	"./axtria/6.jpeg": 454,
	"./axtria/7.jpeg": 4683,
	"./axtria/8.jpeg": 1436,
	"./ey/1.jpeg": 6536,
	"./ibr/1.jpeg": 3369,
	"./ibr/2.jpeg": 2715,
	"./ibr/3.jpeg": 8296,
	"./piramal/1.jpeg": 4261,
	"./piramal/10.jpeg": 3463,
	"./piramal/11.jpeg": 8964,
	"./piramal/12.jpeg": 7872,
	"./piramal/2.jpeg": 6412,
	"./piramal/3.jpeg": 195,
	"./piramal/4.jpeg": 2316,
	"./piramal/5.jpeg": 7516,
	"./piramal/6.jpeg": 1474,
	"./piramal/7.jpeg": 4150,
	"./piramal/8.jpeg": 6346,
	"./piramal/9.jpeg": 253,
	"./saint/1.jpeg": 1091,
	"./saint/2.jpeg": 8638,
	"./saint/3.jpeg": 2092,
	"./saint/4.jpeg": 3674,
	"./saint/5.jpeg": 5837,
	"./wiprowater/1.jpeg": 8200,
	"./wiprowater/2.jpeg": 6345,
	"./wiprowater/3.jpeg": 3222,
	"./wiprowater/4.jpeg": 8646,
	"./wiprowater/5.jpeg": 9550
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1393;